// extracted by mini-css-extract-plugin
module.exports = {"container":"PartnershipPage_container__34w03","title":"PartnershipPage_title__1_YyY","subTitle":"PartnershipPage_subTitle__pUkNb"};